import React, { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
// import { FILE_UPLOAD_FORMAT_OPTIONS } from '../../../HelperMethods/constants';
import { useAttachmentFileChangeHook, useDownloadButtonClicked } from '../../../HelperMethods/CommonHooks';
import { getFileName } from '../../../HelperMethods/UtilityFunctions';

// function getAcceptAttribute(allowedFormats) {
//   if (!allowedFormats || !allowedFormats.length) {
//     return '*';
//   }
//   return allowedFormats.map((format) => FILE_UPLOAD_FORMAT_OPTIONS[format].acceptedExtension).join(',');
// }

export default function AttachmentComponent({
  fieldName,
  fileSizeLimitInMB,
  // allowedFormats,
  uploadedFile,
  onChange,
  disabled,
  errorMessage,
  onUploadStatusChange,
  isRequired = false,
  isRequiredOnCreation = false,
  isCreate = false,
}) {
  const fileInputRef = useRef();
  const [errorMsg, setErrorMsg] = useState(null);
  const loggedInUser = useSelector((state) => state.appReducer.loggedInUser);
  // const acceptAttributes = getAcceptAttribute(allowedFormats);
  const [uploading, onFileChange] = useAttachmentFileChangeHook(onChange, fileSizeLimitInMB, setErrorMsg, loggedInUser);
  React.useEffect(() => {
    if (onUploadStatusChange) onUploadStatusChange(uploading);
  }, [uploading]);
  const onUploadButtonClicked = useCallback(() => {
    fileInputRef.current.click();
  }, [fileInputRef]);

  const onDownloadButtonClicked = useDownloadButtonClicked(uploadedFile);

  const onCancelButtonClicked = useCallback(() => {
    onChange(null);
  }, [onChange]);
  return (
    <div className="attachment-container">
      <label>
        {fieldName}
        {!isCreate && isRequired && <span className="mandatory-resolve-field">*</span>}
        {isCreate ? (
          isRequiredOnCreation ? (
            <span className="mandatory-field">*</span>
          ) : isRequired ? (
            <span className="mandatory-resolve-field">*</span>
          ) : (
            ''
          )
        ) : (
          ''
        )}
      </label>

      {uploadedFile && uploadedFile.key ? (
        <div className="attachment">
          <div style={{ flex: '2 1 0' }}>
            <span>{uploadedFile.fileName || getFileName(uploadedFile.key)}</span>
          </div>
          <div className="no-print" style={{ flex: '1 1 0' }}>
            <Button
              type="button"
              style={{ marginBottom: '16px' }}
              icon="cloud download"
              onClick={onDownloadButtonClicked}
            />
            <Button
              disabled={disabled}
              style={{ marginBottom: '16px' }}
              type="button"
              icon="cancel"
              onClick={onCancelButtonClicked}
            />
          </div>
        </div>
      ) : (
        <div className="no-print">
          <Button
            type="button"
            style={{ marginBottom: '16px' }}
            loading={uploading}
            disabled={uploading || disabled}
            icon="cloud upload"
            onClick={onUploadButtonClicked}
          />
          <input
            style={{ display: 'none' }}
            ref={fileInputRef}
            // accept={acceptAttributes}
            disabled={disabled}
            id={fieldName}
            type="file"
            onChange={onFileChange}
          />
        </div>
      )}
      {(errorMessage || errorMsg) && <div className="errorText">* {errorMessage || errorMsg}</div>}
    </div>
  );
}

AttachmentComponent.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fileSizeLimitInMB: PropTypes.number.isRequired,
  // allowedFormats: PropTypes.arrayOf(PropTypes.string).isRequired,
  uploadedFile: PropTypes.shape({
    key: PropTypes.string,
    bucket: PropTypes.string,
    region: PropTypes.string,
    fileName: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  onUploadStatusChange: PropTypes.func,
  isRequired: PropTypes.bool,
  isRequiredOnCreation: PropTypes.bool,
  isCreate: PropTypes.bool,
};

AttachmentComponent.defaultProps = {
  uploadedFile: null,
  disabled: false,
  errorMessage: null,
};
